import React from 'react';
import { MeasurementColors } from './types';
import { defaultColors } from './util/dataUtils';

const ColorContext = React.createContext<MeasurementColors>(defaultColors);

export default ColorContext;
